// extracted by mini-css-extract-plugin
export default {"root":"EditListingBasicInfoPanel_root__JMvvZ","form":"EditListingBasicInfoPanel_form__jKb9y","listingLink":"EditListingBasicInfoPanel_listingLink__S9UB4"};